export default __webpack_public_path__ + "static/media/z1.c654cea6.jpg";